// Card-only manifest for the CRM Contact. Registered at bootstrap; consumers resolve via getManifest/EntityManifestService.
// Both portals reuse the tenant card verbatim — a Contact renders the same everywhere, so `domains` replays the same object.
import { ActivityEntityName, Contact, CrmSecurityRight, DomainType, SurfaceType } from '@jms/model';
import { RightsService } from '@jms/utils/util.permissions';
import type { EntityManifestCard } from '@workbuddy/services/entities/entity.manifest';
import { registerManifest } from '@workbuddy/services/entities/entity.manifest.registry';

const card: EntityManifestCard<Contact> = {
  component: () => import('./entity.card.renderer/contact.entity.card.renderer.component').then(module => module.ContactEntityCardRendererComponent),
  resolution: 'if-needed',
  isComplete: value => !!(value.mobile || value.phone || value.workPhone || value.email),
  summarize: value => ({ title: value.name ?? 'Not set' }),
};

export const contactManifest = registerManifest<Contact>({
  entity: ActivityEntityName.Contact,
  slug: 'contact',
  presentation: { card },
  domains: {
    [DomainType.ClientPortal]: { presentation: { card } },
    [DomainType.ContractorPortal]: { presentation: { card } },
  },
  surfaces: {
    [SurfaceType.Form]: () => import('./surface/create/contact.create.surface').then(module => module.contactCreateFormSurface),
  },
  operations: {
    create: {
      surface: SurfaceType.Form,
      presentation: { mode: 'dialog', width: 'min(520px, calc(100vw - 40px))' },
      // A contact is a detail of the customer holding it, so adding one follows Customers Edit (WBS-12233).
      authorize: ({ injector }) => injector.get(RightsService).hasRights(CrmSecurityRight.CustomersEdit),
    },
  },
});
